<!--  -->
<template>
<div class="shadow">
<div :class="isMobile?'mintroduce':'introduce'" :show="show">
    <div class="title">新四军军部旧址纪念馆基本情况</div>
    <div class="content">
        <p v-for="(item,i) in introduce" :key='i'>{{item}}</p>
    </div>
    <div class="close" @click="onClose()"><img src="@/assets/images/popup-close.png" alt=""></div>
</div>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
    show:false,
    duration: 0,
    introduce:[
        '新四军军部旧址纪念馆位于宣城市泾县云岭镇，它是依托抗日战争时期，新四军军部驻扎云岭期间留下的主要遗址而建立的革命纪念馆。它是一个由明、清时代的徽派古典建筑组成的建筑群，占地面积2万平方米，是全国首批重点文物保护单位、全国保存最完整的革命旧址群之一。现保存完好的有军部司令部、大会堂、政治部、中共中央东南局等12处旧址，如今古貌依然，规模宏大，雕刻精美，建筑风格独特。',
        '据统计，自建馆50多年以来，共接待来海内外观众达800余万人次，多位党和国家领导人曾亲临该馆视察。如今，新四军军部旧址是全国中小学爱国主义教育基地、全国爱国主义教育示范基地、全国首批国防教育基地、全国首批廉政教育基地、中央组织部备案的干部党性教育基地、全国关心下一代党史国史教育基地、全国我最向往的二十个党史纪念地之一、全国妇女爱国主义教育基地、全省干部党性教育基地;是国家AAAA级旅游景区、全国重点红色旅游景区之一、全国红色旅游精品线路之一、全国红色旅游经典景区之一。'
    ]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    onClose() {
         setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, this.duration);
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.shadow {
    position:fixed;
    z-index:99;
    top:0;
    width:100%;
    height:100%;
    background:url(../../assets/images/bg.jpg)center no-repeat;
    background-size:cover;
}
.introduce {
    width:77.6vw;
    height:37.29vw;
    position:fixed;
    z-index:999;
    left:0;
    right:0;
    bottom:0;
    top:0;
    margin:auto;
    background:url('../../assets/images/popup_bg.png') no-repeat;
    background-size:cover;
    .title {
        margin-top:5vw;
        text-align:center;
        font-size:2.4vw;
        color:#b52223;
        font-family: 'SHSH';
        font-weight: bold;

    }
    .content {
        width:100%;
        margin:0 auto;
        margin-top:20px;
        height:30vw;
        font-size:1.2vw;
        line-height:28px;
        overflow-y:scroll;
        p {
            width:80%;
            margin:0 auto;
            text-indent:2em;
            line-height:40px;
            color:#333;
            font-family: 'SHSB';
            margin-bottom:2vw;

        }
    }
    .close {
        position:absolute;
        top:6vw;
        right:5.2vw;
        width:2.2vw;
        
        margin:auto;

    }
}
.mintroduce {
    width:86.5vw;
    height:70.7vh;
     position:fixed;
    left:0;
    top:10vh;
    right:0;
    margin:auto;
     background:url('../../assets/images/mobile/popup-bg2.png')center/100% 100% no-repeat;
    .title {
        margin:10vh auto 3vh;
        text-align:center;
        font-weight:bold;
        font-size:4.2vw;
        color:#B52223;
        font-family: 'SHSB';

    }
    .content {
        width:100%;        
        margin:0 auto;       
        height:45vh;
        overflow-y:scroll;
        p {
            width:80%;
            margin:0 auto;
            font-size:3.2vw;
            font-family: 'SHSB';
            text-indent:2em;
            color:#111110;
            line-height: 6vw;
            margin-bottom: 1vw;

        }
    }
    .close {
        position:absolute;
        top:5vh;
        right:12vw;
        width:5.7vw;
        height:5.7vw;
        margin:auto;

    }
}
</style>